import clsx from 'clsx';
import { Dispatch, SetStateAction } from 'react';
import { EventAccordionItemProps } from 'src/components/Accordions';
import { useCollapsableViewContext } from 'src/contexts/CollapsableViewContext/CollapsableViewContext';
import {
  MultiSelectScope,
  useMultiSelectionContext,
} from 'src/contexts/MultiSelectionContext';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { EventWithData, Sale } from 'src/WebApiController';
import { Feature } from 'src/WebApiController';

import * as styles from '../../Events/EventPage/EventPage.css';

type SaleEventContentProps = {
  accordionItemProps?: EventWithData;
  saleAccordionItem?: EventAccordionItemProps<Sale>;
  selectedSaleIds: number[];
  setSelectedSaleIds: Dispatch<SetStateAction<number[]>>;
};

export function SaleEventInfoSection({
  accordionItemProps,
  saleAccordionItem,
  selectedSaleIds,
  setSelectedSaleIds,
}: SaleEventContentProps) {
  const { BodyComponent, AfterHeaderComponent } = saleAccordionItem || {};
  const { onScroll, isCollapsedView, isEnabled } = useCollapsableViewContext();

  const hasEventListingTableHotkeysFeature = useUserHasFeature(
    Feature.EventListingTableHotkeys
  );
  const hasSalesTableV2Feature = useUserHasFeature(Feature.SalesTableV2);

  const { selectionMode } = useMultiSelectionContext();
  const isSelectionModeOn = !!selectionMode?.mode;

  return (
    <div className={styles.tableSection}>
      {BodyComponent && accordionItemProps && (
        <div
          className={clsx(
            styles.tableContainer,
            styles.eventPageTableContainer
          )}
        >
          <div className={styles.bulkActionsStickyWrapper}>
            {AfterHeaderComponent && (
              <AfterHeaderComponent
                displayMode={hasSalesTableV2Feature ? 'count-only' : undefined}
              />
            )}
          </div>
          <div
            className={clsx({
              [styles.eventDetailsBodyWrapper]: isEnabled,
              [styles.eventDetailsBodyPadding]:
                !isSelectionModeOn && !isCollapsedView,
            })}
          >
            <BodyComponent
              event={accordionItemProps.event}
              entities={accordionItemProps.entities.sales ?? []}
              entitiesSummary={accordionItemProps.entities.salesSummary}
              entityCount={accordionItemProps.counts.salesCnt ?? 0}
              selectedIds={selectedSaleIds}
              onItemSelectionsChanged={setSelectedSaleIds}
              selectionMode={{ mode: MultiSelectScope.SingleItem }}
              disablePagination
              useTableNavKeys={hasEventListingTableHotkeysFeature}
              useVirtuoso={!hasSalesTableV2Feature}
              onVirtuosoTableScroll={onScroll}
              withOuterPadding={false}
            />
          </div>
        </div>
      )}
    </div>
  );
}
